export default {
  CONFIRMATION: 'overdues_confirmation',
  CHARGE_PAYMENTS: 'charge_overdue_payments',
}

export const OVERDUE_PAYMENTS_STATUS = {
  PENDING: 'pending',
  SUCCESS: 'success',
}
